import React, { useState, useEffect } from "react";
import * as API from './api.js';
import { useSelector } from "react-redux";

const TopBar = ({ showLogo = true, title }) => {
  const [companyLogo, setCompanyLogo] = useState(null)
  const activeProfile = useSelector((state) => state.profile)

  const getActiveTeamInfo = async (teamId) => {
    try {
      const { team } = await API.getActiveTeamInfoAPI(teamId);
      const { ownerdetails } = team
      if (ownerdetails?.company_logo) {
        setCompanyLogo(`${ownerdetails?.company_logo}?${ownerdetails.sas_token}&t${new Date().getTime()}`)
      } else {
        setCompanyLogo(null);
      }
    } catch (err) {
      // popup({ title: "Teams", description: err.message, type: "ERROR" });
      setCompanyLogo(null);
    }
  }

  useEffect(() => {
    if (activeProfile?.activeTeamId) {
      getActiveTeamInfo(activeProfile?.activeTeamId);
    } else if (activeProfile?.user?.company_logo) {
      setCompanyLogo(`${activeProfile?.user?.company_logo}${activeProfile?.user?.sas_token}&t${new Date().getTime()}`)
    } else {
      setCompanyLogo(null)
    }
  }, [activeProfile?.activeTeamId, activeProfile?.user])

  return (
    <div className="top-bar" style={{ display: "flex", gap: "0.6rem", paddingLeft: "30px" }}>
      {(companyLogo && showLogo) && (
        <div style={{ display: "flex", height: "50px", padding: "0px 10px", gap: "1rem", marginTop: "10px" }}>
          <div style={{ height: "50px", transition: "0.3s", margin: 'auto' }}>
            <img
              src={companyLogo}
              style={{ width: "65px", height: "35px", }}
            />
          </div>
          <div style={{ height: "65%", borderRight: "1px solid #E0E0E0", marginTop: "4px" }}></div>
        </div>
      )}
      <div className="top-bar-text">{title}</div>
    </div>

  )
}

export default TopBar;
